import { SimpleProduct} from '@msdyn365-commerce/retail-proxy';
import { getProductUrlSync } from '@msdyn365-commerce-modules/retail-actions';
import { IAny, ICoreContext, IGeneric } from '@msdyn365-commerce/core';
const generateURLForPDP = (product: SimpleProduct, context: ICoreContext<IGeneric<IAny>>) => {
    let newURL = '';
    if(product) {
        const variantProductId = product.RecordId;
        newURL = getProductUrlSync(product, context.actionContext, undefined);
        if(context.app.config.queryBasedVariantSelection) {
            newURL = `${newURL}?variantid=${variantProductId}`;
        }
        return newURL;
    }
    return newURL;
};
export default generateURLForPDP;